import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { MetaConfig } from '@constants/metatags';
import { EventEmitter } from '@ciceksepeti/cs-event-emitter';
import Events from '@constants/events';
var ConditionalMetatags = function () {
    var initialPathname = window.location.pathname;
    var hasQueryString = window.location.search.length > 0;
    var _a = useState(initialPathname), currentPathname = _a[0], setCurrentPathname = _a[1];
    var meta = MetaConfig[currentPathname] || { robots: 'noindex, nofollow' };
    if (hasQueryString) {
        meta.robots = 'noindex, nofollow';
    }
    useEffect(function () {
        var handlePathnameChange = function (event) {
            setCurrentPathname(event.pathname);
        };
        var eventEmitter = new EventEmitter();
        eventEmitter.subscribe(Events.PATHNAME_CHANGE, handlePathnameChange);
        return function () {
            eventEmitter.unsubscribe(Events.PATHNAME_CHANGE, handlePathnameChange);
        };
    }, []);
    return (_jsxs(Helmet, { children: [_jsx("meta", { name: "robots", content: meta.robots }), meta.title ? _jsx("title", { children: meta.title }) : null, meta.canonical ? _jsx("link", { rel: "canonical", href: meta.canonical }) : null, meta.description ? _jsx("meta", { name: "description", content: meta.description }) : null] }));
};
export default ConditionalMetatags;
